import React, { useEffect, useRef } from "react";
import { EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import "../../css/EmblaHome.css";
import { Box, Button, Fade, useTheme } from "@mui/material";
import { LoadSlider } from "../LoadSlider";
import { CardHero } from "../CardHero";
import { ArrowSplideRight } from "../../icons";
import { addToRefsGeneric } from "../../utils/funtions";
import gsap from "gsap";
import { FinalChance } from "../../interfaces/FinalChane";
import { useNavigate } from "react-router-dom";
import {
  NextHomeButton,
  PrevHomeButton,
  usePrevNextHomeButtons,
} from "./components/EmblaHomeButton";

type PropType = {
  slides: FinalChance[];
  options?: EmblaOptionsType;
  isLoading: boolean;
};

export const EmblaHome: React.FC<PropType> = ({
  slides,
  options,
  isLoading,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextHomeButtons(emblaApi);
  const cardHeroRef = useRef<HTMLDivElement[]>([]);
  const addToRefCardHer = addToRefsGeneric(cardHeroRef);
  const navigate = useNavigate();
  const theme = useTheme();

  const goToFinalChance = () => {
    navigate("/collections/final-chance");
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (!cardHeroRef.current) return;

      cardHeroRef.current.forEach((c, i) => {
        gsap.fromTo(
          c,
          {
            y: 90,
            opacity: 0,
            transformPerspective: 1000,
            rotateX: 0.01,
          },
          {
            y: 0,
            opacity: 1,
            ease: "power1.out",
            delay: 0.2 * i,
            scrollTrigger: {
              trigger: c,
              start: "top 80%",
              end: "100%",
              toggleActions: "play reverse play reverse",
            },
          }
        );
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <section className="embla__home">
      {isLoading ? (
        <LoadSlider />
      ) : (
        <Fade in timeout={1500}>
          <Box>
            <Box className="embla__viewport__home" ref={emblaRef}>
              <Box className="embla__container__home">
                {slides.map((p) => (
                  <Box className="embla__slide__home" key={p.id}>
                    <CardHero
                      ref={addToRefCardHer}
                      to={`/products/${p.id}`}
                      image={p.image}
                      alt={p.name}
                      title={p.name}
                      description={p.description}
                      currency="$"
                      price={p.price}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
            <Box className="embla__controls__home">
              <Box>
                <PrevHomeButton
                  onClick={onPrevButtonClick}
                  disabled={prevBtnDisabled}
                />
                <NextHomeButton
                  onClick={onNextButtonClick}
                  disabled={nextBtnDisabled}
                />
              </Box>

              <Button
                onClick={goToFinalChance}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  textTransform: "uppercase !important",
                  backgroundColor: "#171717",
                  padding: "15px 20px",
                  borderRadius: "100vmax !important",
                  color: theme.palette.background.paper,
                }}
              >
                View All
                <ArrowSplideRight
                  sx={{ width: 13, height: 13 }}
                  htmlColor="#c4c4c4ff"
                />
              </Button>
            </Box>
          </Box>
        </Fade>
      )}
    </section>
  );
};
